const announceTime = [
	{ value: null, text: 'ไม่ระบุ' },
	{ divider: true },
	{ value: '3', text: 'ภายใน 3 วัน' },
	{ value: '7', text: 'ภายใน 1 สัปดาห์' },
	{ value: '14', text: 'ภายใน 2 สัปดาห์' },
	{ value: '30', text: 'ภายใน 1 เดือน' }
]

const areaSpaceItems = [
	200, 300, 400, 500, 1000, 2000, 3000, 5000, 10000, 20000, 30000, 50000
]

const priceItems = [
	5000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 50000, 60000, 70000, 80000, 90000, 100000,
	500000, 1000000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000, 4500000,
	5000000, 5500000, 6000000, 6500000, 7000000, 7500000, 8000000, 8500000, 9000000,
	9500000, 10000000, 11000000, 12000000, 13000000, 14000000, 15000000, 20000000, 50000000
]

const propertyDirection = [
	{ value: null, text: 'ไม่ระบุ' },
	{ divider: true },
	{ value: 'N', text: 'เหนือ' },
	{ value: 'NE', text: 'ตะวันออกเฉียงเหนือ' },
	{ value: 'NW', text: 'ตะวันตกเฉียงเหนือ' },
	{ value: 'E', text: 'ตะวันออก' },
	{ value: 'W', text: 'ตะวันตก' },
	{ value: 'SW', text: 'ตะวันตกเฉียงใต้' },
	{ value: 'SE', text: 'ตะวันออกเฉียงใต้' },
	{ value: 'S', text: 'ใต้' }
]

const txOption = [
	{ value: 'ALL', text: 'ขาย/เช่า' },
	{ value: 'BUY', text: 'ขาย' },
	{ value: 'RENT', text: 'เช่า' }
]

const useFor = [
	// 'บ้านเดี่ยว', 'บ้านแฝด', 'ทาวน์เฮ้าส์', 'ทาวน์โฮม', 'คอนโดมิเนียม',
	// 'เอื้ออาทร', 'อาคารพาณิชย์', 'ที่ดิน', 'โกดัง', 'โรงงาน', 'โรงแรม',
	// 'สำนักงาน', 'พื้นที่ขายของ', 'หอพัก', 'อพาร์ทเม้นท์', 'อื่นๆ'
	'บ้าน', 'ทาวน์เฮ้าส์', 'คอนโด', 'อาคารพาณิชย์', 'ที่ดิน',
	'โกดังโรงงาน', 'อพาร์ทเม้นท์', 'โรงแรม', 'สำนักงาน', 'อื่นๆ',
]

const useForCommercialItems = [
	{ value: 'LAND', text: 'ที่ดิน' },
	{ value: 'COMMERCIAL_BUILDING', text: 'อาคารพาณิชย์' },
	{ value: 'FACTORY', text: 'โรงงาน' },
	{ value: 'APARTMENT', text: 'อพาร์ทเม้นท์' },
	{ value: 'OTHERS', text: 'อื่นๆ' }
]

const useForRestItems = [
	// { value: 'HOME', text: 'บ้านเดี่ยว' },
	{ value: 'HOME', text: 'บ้าน' },
	// { value: 'TWINHOUSE', text: 'บ้านแฝด' },
	{ value: 'TOWNHOUSE', text: 'ทาวน์เฮ้าส์' },
	// { value: 'TOWNHOME', text: 'ทาวน์โฮม' },
	{ value: 'CONDO', text: 'คอนโด' },
	// { value: 'GHC', text: 'เอื้ออาทร' }
]

const usefulSpaceItems = [
	10, 20, 30, 40, 50, 80, 150, 200, 300, 400, 500, 1000
]

export {
	announceTime,
	areaSpaceItems,
	priceItems,
	propertyDirection,
	txOption,
	useFor,
	useForCommercialItems,
	useForRestItems,
	usefulSpaceItems
}
